






































import Vue from 'vue'
import { exportProductTemplateGET, importProductsPOST } from '@/api/api'

export default Vue.extend({
  name: 'ImportProductModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    typeId: {
      type: String
    }
  },
  data() {
    return {
      loading: false,
      fileList: []
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.fileList = []
      }
    }
  },
  methods: {
    // 下载模板
    downloadTemplate() {
      exportProductTemplateGET(this.typeId).then((res: any) => {
        // 创建隐藏的可下载链接
        var a = document.createElement('a')
        a.download = `${this.$t('page_product_imort_template')}.xlsx`
        a.style.display = 'none'
        // 字符内容转变成blob地址
        // var blob = new Blob([res])
        let url = URL.createObjectURL(res)
        a.href = url
        // 触发点击
        document.body.appendChild(a)
        a.click()
        // 然后移除
        URL.revokeObjectURL(url)
        document.body.removeChild(a)
      })
    },
    handleRemove(file: any) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
    },
    // 分步上传
    beforeUpload(file: any) {
      this.fileList = [...this.fileList, file]
      return false
    },
    handleSubmit() {
      const { fileList } = this
      const formData = new FormData()
      fileList.forEach(file => {
        formData.append('file', file)
      })
      this.uploading = true
      importProductsPOST(formData).then((res: any) => {
        this.fileList = []
        const {
          failUploadRecords,
          successUploadRecords,
          uploadTotal
        } = res.data.data
        // this.$message.info({content: `共上传${uploadTotal}条数据，成功${successUploadRecords}条，失败${failUploadRecords}条`,duration: 6})
        this.$message.info({
          content: this.$t('page_product_import_result').replace('{uploadTotal}', uploadTotal).replace('{successUploadRecords}', successUploadRecords).replace('{failUploadRecords}', failUploadRecords),
          duration: 6
        })
        this.$emit('close', true)
      }).finally(() => {
        this.loading = false
      })
    },
    close() {
      this.$emit('close')
    }
  }
})
